webpackJsonp([261807626633106],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(79));
	
	var _reactHelpers = __webpack_require__(112);
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left'
	    },
	    container: {
	      position: 'relative'
	    },
	    focusVisible: {
	      backgroundColor: theme.palette.action.hover
	    },
	    default: {
	      paddingTop: 12,
	      paddingBottom: 12
	    },
	    dense: {
	      paddingTop: theme.spacing.unit,
	      paddingBottom: theme.spacing.unit
	    },
	    disabled: {
	      opacity: 0.5
	    },
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	    gutters: theme.mixins.gutters(),
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positionned.
	      paddingRight: theme.spacing.unit * 4
	    }
	  };
	};
	
	exports.styles = styles;
	
	var ListItem =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(ListItem, _React$Component);
	
	  function ListItem() {
	    (0, _classCallCheck2.default)(this, ListItem);
	    return (0, _possibleConstructorReturn2.default)(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  (0, _createClass2.default)(ListItem, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        dense: this.props.dense || this.context.dense || false
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          button = _props.button,
	          childrenProp = _props.children,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          componentProp = _props.component,
	          ContainerComponent = _props.ContainerComponent,
	          _props$ContainerProps = _props.ContainerProps;
	      _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	      var ContainerClassName = _props$ContainerProps.className,
	          ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	          dense = _props.dense,
	          disabled = _props.disabled,
	          disableGutters = _props.disableGutters,
	          divider = _props.divider,
	          focusVisibleClassName = _props.focusVisibleClassName,
	          other = (0, _objectWithoutProperties2.default)(_props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
	      var isDense = dense || this.context.dense || false;
	
	      var children = _react.default.Children.toArray(childrenProp);
	
	      var hasAvatar = children.some(function (value) {
	        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
	      });
	      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
	      var className = (0, _classnames.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
	      var componentProps = (0, _objectSpread2.default)({
	        className: className,
	        disabled: disabled
	      }, other);
	      var Component = componentProp || 'li';
	
	      if (button) {
	        componentProps.component = componentProp || 'div';
	        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
	        Component = _ButtonBase.default;
	      }
	
	      if (hasSecondaryAction) {
	        // Use div by default.
	        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	        if (ContainerComponent === 'li') {
	          if (Component === 'li') {
	            Component = 'div';
	          } else if (componentProps.component === 'li') {
	            componentProps.component = 'div';
	          }
	        }
	
	        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
	          className: (0, _classnames.default)(classes.container, ContainerClassName)
	        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
	      }
	
	      return _react.default.createElement(Component, componentProps, children);
	    }
	  }]);
	  return ListItem;
	}(_react.default.Component);
	
	ListItem.propTypes =  false ? {
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`).
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is rendered.
	   */
	  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Properties applied to the container element when the component
	   * is used to display a `ListItemSecondaryAction`.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : {};
	ListItem.defaultProps = {
	  button: false,
	  ContainerComponent: 'li',
	  dense: false,
	  disabled: false,
	  disableGutters: false,
	  divider: false
	};
	ListItem.contextTypes = {
	  dense: _propTypes.default.bool
	};
	ListItem.childContextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(125));

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(30));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      marginRight: theme.spacing.unit * 2,
	      color: theme.palette.action.active,
	      flexShrink: 0
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	
	function ListItemIcon(props) {
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
	  return _react.default.cloneElement(children, (0, _objectSpread2.default)({
	    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
	  }, other));
	}
	
	ListItemIcon.propTypes =  false ? {
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : {};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(229));

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _Typography = _interopRequireDefault(__webpack_require__(20));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      flex: '1 1 auto',
	      minWidth: 0,
	      padding: "0 ".concat(theme.spacing.unit * 2, "px"),
	      '&:first-child': {
	        paddingLeft: 0
	      }
	    },
	    inset: {
	      '&:first-child': {
	        paddingLeft: theme.spacing.unit * 7
	      }
	    },
	    dense: {
	      fontSize: theme.typography.pxToRem(13)
	    },
	    primary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    secondary: {
	      '&$textDense': {
	        fontSize: 'inherit'
	      }
	    },
	    textDense: {}
	  };
	};
	
	exports.styles = styles;
	
	function ListItemText(props, context) {
	  var _classNames3;
	
	  var children = props.children,
	      classes = props.classes,
	      classNameProp = props.className,
	      disableTypography = props.disableTypography,
	      inset = props.inset,
	      primaryProp = props.primary,
	      secondaryProp = props.secondary,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "secondary"]);
	  var dense = context.dense;
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && !disableTypography) {
	    primary = _react.default.createElement(_Typography.default, {
	      variant: "subheading",
	      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      component: "span"
	    }, primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && !disableTypography) {
	    secondary = _react.default.createElement(_Typography.default, {
	      variant: "body1",
	      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
	      color: "textSecondary"
	    }, secondary);
	  }
	
	  return _react.default.createElement("div", (0, _extends2.default)({
	    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
	  }, other), primary, secondary);
	}
	
	ListItemText.propTypes =  false ? {
	  /**
	   * Alias for the `primary` property.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node
	} : {};
	ListItemText.defaultProps = {
	  disableTypography: false,
	  inset: false
	};
	ListItemText.contextTypes = {
	  dense: _propTypes.default.bool
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(231));

/***/ }),

/***/ 1428:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNjhweCIgaGVpZ2h0PSI3MHB4IiB2aWV3Qm94PSIwIDAgNjggNzAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJHcm91cCIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPHBhdGggZD0iTTYwLjE2MiwwLjU4MiBDNjAuMDgzLDAuNTgyIDYwLjAwNCwwLjYwMSA1OS45MzQsMC42MzcgTDMzLjk5NiwxMy45NDIgTDguMDU3LDAuNjM3IEM3Ljk4MiwwLjU5OSA3Ljg5OSwwLjU4IDcuODE2LDAuNTgyIEM3LjU0NSwwLjU4OSA3LjMyOSwwLjgxMSA3LjMyOSwxLjA4MiBMNy4zMjksNy43NDQgQzcuMzI5LDcuOTcyIDcuNDg0LDguMTcyIDcuNzA1LDguMjI4IEwzMy42NjIsMTQuODgyIEMzMy43NzQsMTQuOTEgMzMuODkxLDE0Ljg5OSAzMy45OTYsMTQuODUxIEMzNC4xLDE0Ljg5OSAzNC4yMTgsMTQuOTEgMzQuMzI5LDE0Ljg4MiBMNjAuMjg2LDguMjI4IEM2MC41MDcsOC4xNzEgNjAuNjYyLDcuOTcyIDYwLjY2Miw3Ljc0NCBMNjAuNjYyLDEuMDgyIEM2MC42NjIsMC44MDYgNjAuNDM5LDAuNTgyIDYwLjE2MiwwLjU4MiBaIiBpZD0iU2hhcGUiPjwvcGF0aD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlNoYXBlIiBwb2ludHM9IjY4IDEwLjE3NSAzNi4zNzMgMTguNDg3IDM2LjM3MyA2OS40MTggNjggNjAuMzQ5Ij48L3BvbHlnb24+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJTaGFwZSIgcG9pbnRzPSIwIDYwLjM0OSAzMS42MTkgNjkuNDE4IDMxLjYxOSAxOC40ODcgMCAxMC4xNzQiPjwvcG9seWdvbj4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Hidden = __webpack_require__(162);
	
	var _Hidden2 = _interopRequireDefault(_Hidden);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _List = __webpack_require__(228);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ListItem = __webpack_require__(126);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _ListItemIcon = __webpack_require__(230);
	
	var _ListItemIcon2 = _interopRequireDefault(_ListItemIcon);
	
	var _SvgIcon = __webpack_require__(93);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _ListItemText = __webpack_require__(232);
	
	var _ListItemText2 = _interopRequireDefault(_ListItemText);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(11);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _study = __webpack_require__(1428);
	
	var _study2 = _interopRequireDefault(_study);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StudiesPage = function StudiesPage(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.studies);
	  var studies = (0, _mapper.mapStudies)(props.data.studies);
	
	  var all = props.data.all.edges.map(function (study) {
	    return (0, _mapper.mapStudy)(study.node);
	  });
	
	  console.dir(all);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, { uid: 'studies', title: studies.title, subtitle: studies.subtitle }),
	    _react2.default.createElement(Teaser, { image: studies.featured_bg }),
	    _react2.default.createElement(Focus, { study: studies.featured_study }),
	    studies.list.map(function (study, index) {
	      return _react2.default.createElement(
	        'div',
	        { key: index },
	        _react2.default.createElement(Content, { study: study })
	      );
	    }),
	    _react2.default.createElement(StudyNav, { all: all, featured: studies.list }),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	var Teaser = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      image = props.image;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.teaser },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 0 },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement('div', {
	          style: {
	            background: 'url(' + image.src + ')',
	            backgroundPosition: 'center',
	            backgroundSize: 'cover',
	            height: '40vh'
	          }
	        })
	      )
	    )
	  );
	});
	
	var Focus = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      study = props.study;
	
	  var LinkButton = function LinkButton(props) {
	    return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: '/study/' + study.uid }, props));
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: classes.focus },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        _Hidden2.default,
	        { xsDown: true },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.focusFloat) },
	          study.data.customer && _react2.default.createElement('img', {
	            src: study.data.customer.document[0].data.logo.localFile.childImageSharp.original.src,
	            style: {
	              display: 'inline',
	              background: '#00a9e4',
	              height: 150,
	              marginLeft: '-5.5rem',
	              marginTop: '-2rem',
	              marginBottom: '2rem',
	              boxShadow: '10px 10px 5px 0px rgba(0,0,0,0.5)'
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: classes.focusFloatStudies },
	            _react2.default.createElement(
	              _Grid2.default,
	              { container: true, spacing: 0, className: classes.focusText },
	              _react2.default.createElement(
	                _Grid2.default,
	                { item: true, xs: 12 },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { className: classes.focusSub, gutterBottom: true },
	                  study.data.title.text
	                ),
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { className: classes.focusText },
	                  study.data.lead.text
	                ),
	                _react2.default.createElement(
	                  _Button2.default,
	                  {
	                    component: LinkButton,
	                    className: (0, _classnames2.default)(
	                    // classes.studylistLink,
	                    classes.focusLink)
	                  },
	                  'Read more'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Content = function Content(props) {
	  var study = props.study;
	
	  return study.type === 'study_list' ? _react2.default.createElement(StudyList, { studies: study.contents }) : study.type === 'study_quote' ? _react2.default.createElement(_quote2.default, { quote: study.quote }) : null;
	};
	
	var StudyList = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      studies = props.studies;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.studyList },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Hidden2.default,
	          { xsDown: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 16 },
	            studies.map(function (study, index) {
	              return _react2.default.createElement(
	                _Grid2.default,
	                { key: index, item: true, xs: 6 },
	                _react2.default.createElement(Study, { study: study, classes: classes })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _Hidden2.default,
	          { smUp: true },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              studies.map(function (study, index) {
	                return _react2.default.createElement(Study, { key: index, study: study, classes: classes });
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Study = function Study(props) {
	  var classes = props.classes,
	      study = props.study,
	      index = props.index;
	
	
	  console.log('STUDY', study);
	
	  var LinkButton = function LinkButton(props) {
	    return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: '/study/' + study.uid }, props));
	  };
	  return _react2.default.createElement(
	    'div',
	    { key: index, className: classes.studies },
	    _react2.default.createElement(
	      _Grid2.default,
	      { container: true, spacing: 40, className: classes.studyItem },
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              whiteSpace: 'nowrap',
	              display: 'flex',
	              alignItems: 'center',
	              background: '#00a9e4',
	              padding: '.5rem',
	              justifyContent: 'center'
	            }
	          },
	          study.customer && _react2.default.createElement('img', {
	            src: study.customer.logo.localFile.childImageSharp.original.src,
	            style: { height: 40 }
	          })
	        ),
	        _react2.default.createElement('div', {
	          className: classes.studyThumbnail,
	          style: { backgroundImage: 'url(' + study.study_bg.src + ')' }
	        })
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'title', gutterBottom: true },
	          study.title.text
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { variant: 'caption' },
	          study.published
	        ),
	        _react2.default.createElement(
	          _Typography2.default,
	          { className: classes.studylistText },
	          study.lead.text
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { item: true, xs: 12 },
	        _react2.default.createElement(
	          _Button2.default,
	          { component: LinkButton, className: classes.studylistLink },
	          'Read more'
	        )
	      )
	    )
	  );
	};
	
	var StudyNav = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var all = props.all,
	      featured = props.featured,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.blogStudyNavItems },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.centred },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 40 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, className: classes.title },
	            _react2.default.createElement(
	              _Typography2.default,
	              {
	                variant: 'headline',
	                className: classes.blogStudyNavTitle
	              },
	              'All Client Studies'
	            ),
	            all.map(function (item) {
	              var active = false;
	              featured.map(function (list) {
	                if (list.type === 'blog_list') {
	                  list.contents.find(function (x) {
	                    if (x.uid === item.uid) {
	                      active = true;
	                    }
	                  });
	                }
	              });
	              return _react2.default.createElement(
	                _ListItem2.default,
	                {
	                  key: item.uid,
	                  button: true,
	                  component: _gatsbyLink2.default,
	                  to: '/study/' + item.uid
	                },
	                _react2.default.createElement('img', { src: _study2.default, className: classes.blogStudyNavIcon }),
	                _react2.default.createElement(_ListItemText2.default, {
	                  primary: item.title.text,
	                  secondary: item.published,
	                  classes: {
	                    primary: classes.blogStudyItemHead,
	                    secondary: classes.blogStudyItemSub
	                  }
	                })
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_site2.default)(StudiesPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-studies-js-a8dbd1a9fcaf5cc785bb.js